// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ss-2";
export var chatLink = "_ss-0";
export var chatText = "_ss-1";